import { getUUID, usePublicProgressStateStore, } from "@annunciate/core";
export const getContentProgress = (client, contentId) => {
    const uuid = getUUID();
    let progress;
    if (uuid) {
        progress = client.getQueryData([
            `progress`,
            { contentId: contentId, uuid: uuid },
        ]);
    }
    else {
        progress = usePublicProgressStateStore
            .getState()
            .progress.find((item) => item.contentId === contentId);
    }
    return progress;
};
//# sourceMappingURL=getContentProgress.js.map